import { t } from "@/i18n-js/instance";
import { useSelectedBlock } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { Icon } from "@circle-react-shared/Icon";
import { BlockActionButton } from "./BlockActionButton";

export const MoveDown = () => {
  const { canMoveDown, moveSelectedBlock } = useSelectedBlock();

  return (
    <BlockActionButton
      onClick={() => moveSelectedBlock("down")}
      disabled={!canMoveDown}
      title={t("builder_ui.editor.move_down")}
    >
      <Icon type="16-arrow-down" size={16} />
    </BlockActionButton>
  );
};
